import React from 'react'


const MarkerIcon = (props) => (
    
<svg xmlns="http://www.w3.org/2000/svg" width="18" height="28" viewBox="0 0 18 28" fill="none">
<g filter="url(#filter0_d_1553:39286)">
<path d="M17 9C17 16.2 9 21.8 9 21.8C9 21.8 1 16.2 1 9C1 6.87827 1.84285 4.84344 3.34315 3.34315C4.84344 1.84285 6.87827 1 9 1C11.1217 1 13.1566 1.84285 14.6569 3.34315C16.1571 4.84344 17 6.87827 17 9Z" fill="#1D1D1B" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8.99956 12.2C10.7669 12.2 12.1996 10.7674 12.1996 9.00005C12.1996 7.23274 10.7669 5.80005 8.99956 5.80005C7.23225 5.80005 5.79956 7.23274 5.79956 9.00005C5.79956 10.7674 7.23225 12.2 8.99956 12.2Z" fill="white" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<filter id="filter0_d_1553:39286" x="0.25" y="0.25" width="17.5" height="27.3" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feMorphology radius="6" operator="erode" in="SourceAlpha" result="effect1_dropShadow_1553:39286"/>
<feOffset dy="6"/>
<feGaussianBlur stdDeviation="2.5"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1553:39286"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1553:39286" result="shape"/>
</filter>
</defs>
</svg>

)


export {
    MarkerIcon
}